import React from "react";

const MyData = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fillRule="evenodd">
      <path
        d="M12 3L5 6.09v4.637c0 4.289 2.987 8.3 7 9.273 4.013-.974 7-4.984 7-9.273V6.091L12 3z"
        fillRule="nonzero"
      />
      <path fill="none" d="M0 0h24v24H0z" />
    </g>
  </svg>
);

export default MyData;
